export default __webpack_public_path__ + "static/media/DN_Icon.b964479e.svg";